module.exports = __webpack_public_path__ + "img/Asset 2.b7754ff4.png";